






































































































































import Vue from 'vue'
import {Component, Prop, Watch} from 'vue-property-decorator'
import Portfolio from "@/lib/models/Portfolio";
import User from "@/lib/models/User";
import PortfolioMove from "@/lib/models/PortfolioMove";
import PriceUpdate from "@/lib/models/PriceUpdate";
import SimpleChart from "@/components/portfolio/charts/SimpleChart.vue";
import {defaultCurrency} from "@/lib/models/sumbols";

@Component({
    components: {
        SimpleChart,
        MonthChart: () => import("@/components/portfolio/charts/MonthChart.vue"),
        HistoryTableMovement: () => import("./historyTableMovements.vue"),
        HistoryTablePriceUpdates: () => import("./historyTablePriceUpdates.vue")
    }
})
export default class PortfolioItem extends Vue {
    @Prop() portfolio!: Portfolio;
    @Prop() user!: User;
    @Prop() expanded!: boolean;
    @Prop() showEditModal!: (portfolioItem: Portfolio) => void;
    @Prop() expandPortfolio!: (portfolioItem: Portfolio) => void;
    @Prop() showEditMovementModal!: (portfolioItem: Portfolio, portfolioMoveItem: PortfolioMove | null) => void;
    @Prop() showEditPriceUpdateModal!: (portfolioItem: Portfolio, priceUpdate: PriceUpdate | null) => void;

    @Watch('portfolio')
    onChangePortfolio() {
        this.reloadPortfolioData();
    }

    totalInvested: number = 0;
    latestUpdateValue: number = 0;
    movementHistoryVisible: boolean = false;
    priceUpdatesHistoryVisible: boolean = false;

    mounted() {
        this.reloadPortfolioData();
    }

    toggleMovementHistory() {
        this.movementHistoryVisible = !this.movementHistoryVisible;
    }

    togglePriceUpdateHistory() {
        this.priceUpdatesHistoryVisible = !this.priceUpdatesHistoryVisible;
    }

    get currency() {
        return this.portfolio && this.portfolio.currency ? this.portfolio.currency : (this.user ? this.user.currency : defaultCurrency);
    }

    reloadPortfolioData() {
        if (this.portfolio) {
            this.totalInvested = this.portfolio.totalInvested();
            this.latestUpdateValue = this.portfolio.latestUpdateValue();
        }
    }


}
